export const LIVE_TYPE_GAME = [
  "live dealer",
  "roulette",
  "baccarat",
  "poker",
  "andar bahar",
  "dragon tiger",
  "sic bo",
  "teen patti",
  "card"
];

export const LIVE_PROVIDER_NAME = ["Ezugi", "Vivo"];

export const checkGameIsLive = (game) => {
  const providerName = game.providerName || game.provider;
  return LIVE_TYPE_GAME.includes(game.type) && LIVE_PROVIDER_NAME.includes(providerName);
};
